module.exports = __webpack_public_path__ + "images/e8acc84f7f7bf30655efd87535faf39d.png";